import { Link } from '@tanstack/react-router';
import { Users, ChevronRight, Info } from 'lucide-react';

interface BatchHubHeaderProps {
  batchName: string;
  studentCount: number;
}

export function BatchHubHeader({ batchName, studentCount }: BatchHubHeaderProps) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <nav className="flex items-center gap-1.5 text-xs" aria-label="Breadcrumb">
          <Link to="/courses" className="text-[#9ca3af] transition-colors hover:text-[#ff5a1f]">My Batches</Link>
          <ChevronRight className="size-3 text-[#9ca3af]" />
          <span className="font-medium text-[#ff5a1f]">{batchName}</span>
        </nav>
        <h1 className="pt-3 text-[34px] font-bold leading-[1.05] tracking-tight text-[#111827] sm:text-[52px] sm:leading-[52px]">
          {batchName}
        </h1>
        <div className="flex flex-wrap items-center gap-4 pt-4 text-sm text-[#9ca3af]">
          <span className="flex items-center gap-1.5">
            <Users className="size-3.5" />
            {studentCount} Students
          </span>
        </div>
      </div>
      <button
        type="button"
        disabled
        title="Coming soon"
        className="mt-1 inline-flex h-11 cursor-not-allowed items-center gap-2 rounded-[14px] border border-[#ececec] bg-white px-[21px] text-sm font-semibold text-[#111827] shadow-[0px_1px_1.5px_rgba(0,0,0,0.1),0px_1px_1px_rgba(0,0,0,0.1)]"
      >
        <Info className="size-[15px]" />
        Batch Details
      </button>
    </div>
  );
}
